import { render, staticRenderFns } from "./RegistryLaunchPhase.vue?vue&type=template&id=d4c92176&"
import script from "./RegistryLaunchPhase.vue?vue&type=script&lang=js&"
export * from "./RegistryLaunchPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RegistryLaunchPhase.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports